import React from 'react';
import { useTranslation } from 'react-i18next';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onNext: () => void;
    onPrevious: () => void;
}

const Pagination: React.FC<PaginationProps> = ({
    currentPage,
    totalPages,
    onNext,
    onPrevious
}) => {
    const { t } = useTranslation('translation');
    return (
        <div className="flex justify-between w-full mt-20 pt-20">
            <button
                className={`px-4 py-2 rounded ${currentPage === 1 ? 'cursor-not-allowed opacity-50' : ''}`}
                onClick={onPrevious}
                disabled={currentPage === 1}
            >
                {t('cw_lp_pagination_1')}
            </button>
            <span>
                {t('cw_lp_pagination_2_currentPage_totalPages', {
                    currentPage, totalPages
                })}
            </span>
            <button
                className={`px-4 py-2 rounded ${currentPage === totalPages ? 'cursor-not-allowed opacity-50' : ''}`}
                onClick={onNext}
                disabled={currentPage === totalPages}
            >
                {t('cw_lp_pagination_3')}
            </button>
        </div>
    );
};

export default Pagination;
